import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import Home from "./components/Home";
import NavBar from "./components/NavBar";
import Auth from "./components/Auth";
import SinglePost from "./components/SinglePost";
import User from "./components/User";

import {fetchPosts} from "./redux/actions/post";

function App() {
    const dispatch = useDispatch();
    const posts = useSelector(state => state.posts);
    const user = JSON.parse(localStorage.getItem("profile"))?.user;

    useEffect(() => dispatch(fetchPosts()), []);

    const SinglePostPage = ({ match }) => {
        const id = match.params.id;
        const post = posts.filter(p => p._id === String(id))[0];

        return <SinglePost post={post} />
    }

    return (
        <div>
            <NavBar />

            <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/auth" component={Auth} />
                <Route exact path="/:id" component={User} />
                <Route exact path="/p/:id" component={SinglePostPage} />

                <Redirect to="/" />
            </Switch>
        </div>
    )
}

export default App;